import React from 'react';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import CoursBar from './cours_bar';
import Icon from '@mdi/react';
import { useHistory } from 'react-router-dom';
import ApiService from '../../services/ApiService';
import { mdiPlusCircleOutline, mdiMinusCircleOutline } from '@mdi/js';
import CustomButtons from '../Elements/Buttons/customButton';
import axios from 'axios';
import { API_URL } from '../../config';

const styleEventDetailsHide = { display: 'none' };
const styleEventDetails = { width: '100%', height: 'fit-content', padding: '12px 0px' };
const styleEventDetailTitle = {
    width: '98%',
    height: '29px',
    'background-color': '#f5f5f5',
    display: 'flex',
    'justify-content': 'center',
    'align-items': 'center',
};
const styleEventDetail = {
    width: '98%',
    'background-color': '#e3e3e3',
    display: 'flex',
    'justify-content': 'center',
    'align-items': 'center',
};



const EventDetail = (props) => {
    const apiService = ApiService.getInstance();
    const history = useHistory();
    const proxySendURL = `${API_URL}ProxySend`;
    const [isExpand, setIsExpand] = useState(false);
    let mainLoaderTaskId;
    const configPay = {
        headers: { Authorization: 'Bearer ' + `${localStorage.getItem('token')}` },
    }; 
    let globalResponse;
    let moreData = getDetails();
    function changeView() {
        if (isExpand) {
            setIsExpand(false);
        } else {
            setIsExpand(true);
        }
    }
    
   
    const payWithoutProxy = (el) => {

            apiService.apiPost('CalculateProductForUser', el, (response) => {
            
                if(response.data.responseStatusCode == 200){
                 
                    window.location.replace(response.data.responseBody.body.html)}
            });
        
    };

    const toPayChange = (el) => {
        const formData = {
            type: 'Payment',
            body: {
                usersID: props.data.payer_UsersID,
                current_LocalizationsID: '-1',
                NIP: '',
                paymentMethodsDVID: '5',
                product: {
                    productsID: props.data.productsID,
                    localizationsID: props.data.localizationsID,
                },
                usersPaymentsSchedulesID: props.data.usersPaymentsSchedulesID,
            },
        };

        axios
            .post(proxySendURL, el, configPay)
            .then((response) => {
                globalResponse = response.data.requestId;
               
                methodProxyGetMessage();
            })
            .catch(function (error) {
                if (error.response.status == 401) {
                    history.push('/Error_sesja_wygasla');

                    apiService.stopLoaderTask(mainLoaderTaskId);
                }
            });
    };

    const methodProxyGetMessage = () => {
        const proxyGetMessageURL = `${API_URL}ProxyGetMessage?requestId=` + globalResponse;
        axios
            .get(proxyGetMessageURL, configPay)
            .then((proxyGetMessageUrlResponse) => {
          
                if (proxyGetMessageUrlResponse.data.recheck == false) {
                    if (proxyGetMessageUrlResponse.data.responseBody.body.html) {
                        window.location.replace(
                            proxyGetMessageUrlResponse.data.responseBody.body.html
                        );
                    } else if (proxyGetMessageUrlResponse.data.responseBody.body.key === 20) {
                        apiService.stopLoaderTask(mainLoaderTaskId);
                        history.push(
                            `/Potwierdzenie_zakupu/${proxyGetMessageUrlResponse.data.responseBody.body.sessionID}`
                        );
                    } else {
                        history.push(`/Potwierdzenie_zakupu`);

                        apiService.stopLoaderTask(mainLoaderTaskId);
                    }
                } else if (proxyGetMessageUrlResponse.data.recheck == true) {
                    setTimeout(() => methodProxyGetMessage(), 5000);
                }
            })
            .catch(function (error) {
                if (error.response != null) {
                    if (error.response.status == 401) {
                        history.push('/Error_sesja_wygasla');

                        apiService.stopLoaderTask(mainLoaderTaskId);
                    }
                } else {
                    window.location.replace(
                        '"https://panelklienta.egurrola.com/Error_ogolny'
                    );

                    apiService.stopLoaderTask(mainLoaderTaskId);
                }
            });
    };

    function getDetails() {
        if (props.dataSecund != undefined) {
            for (var i = 0; i < props.dataSecund.length; i++) {
                if (props.dataSecund[i].courseHeadingName == props.data.courseHeadingName) {
                    return props.dataSecund[i];
                }
            }
        }
    }
    const openNewWindow = (contractID) => {
        // Adres URL nowego okna
        localStorage.setItem("contractData",JSON.stringify(props.data))
        const url = 'https://aden-eds-portal-dev.azurewebsites.net/Contract';
    
        // Otwieramy nowe okno przeglądarki
        window.open(url, '_blank');
      };
    return (
        <>
            <div className="eventDetailsWrapper">
                <div
                    className={
                        isExpand ? 'eventDetailsHeader choosenCourseBar' : 'eventDetailsHeader'
                    }
                    onClick={changeView}
                >
                    <p>{props.data.courseHeadingName}</p>
                    <p>{props.data.contractPeriodFrom + '/' + props.data.contractPeriodTo}</p>
                    <Icon
                        size={1}
                        path={isExpand ? mdiMinusCircleOutline : mdiPlusCircleOutline}
                        color={isExpand ? '#CC0033' : 'green'}
                    ></Icon>
                </div>
                {isExpand ? (
                    <div className="eventsDetails" style={styleEventDetails}>
                        <div className="eventsDetails_row">
                            <div className="eventsDetails_cell">
                                <p className="eventsDetails_cellTittle">GRUPA</p>
                                <p className="eventsDetails_cellContent">
                                    {props.data.courseHeadingName}
                                </p>
                            </div>
                            <div className="eventsDetails_cell">
                                <p className="eventsDetails_cellTittle">NUMER UMOWY</p>
                                <p className="eventsDetails_cellContent">
                                    {props.data.contractSygnature}
                                </p>
                            </div>
                            <div className="eventsDetails_cell">
                                <p className="eventsDetails_cellTittle">STATUS</p>
                                <p className="eventsDetails_cellContent">
                                    {props.data.contractStatusName}
                                </p>
                            </div>
                        </div>
                        <div className="eventsDetails_row">
                            <div className="eventsDetails_cell">
                                <p className="eventsDetails_cellTittle">UCZESTNIK</p>
                                <p className="eventsDetails_cellContent">
                                    {props.data.userFirstName + ' ' + props.data.userLastName}
                                </p>
                            </div>
                            <div className="eventsDetails_cell">
                                <p className="eventsDetails_cellTittle">PŁATNIK</p>
                                <p className="eventsDetails_cellContent">{props.data.payerName}</p>
                            </div>
                            <div className="eventsDetails_cell">
                                <p className="eventsDetails_cellTittle">DATA OD/DATA DO</p>
                                <p className="eventsDetails_cellContent">
                                    {props.data.contractPeriodFrom +
                                        '/' +
                                        props.data.contractPeriodTo}
                                </p>
                            </div>
                        </div>
                        <div className="eventsDetails_row">
                            <div className="eventsDetails_cell">
                                <p className="eventsDetails_cellTittle">KWOTA UMOWY</p>
                                <p className="eventsDetails_cellContent">
                                    {props.data.contractAmount.toFixed(2).toString().replace(".",",")}
                                </p>
                            </div>
                            <div className="eventsDetails_cell">
                                <p className="eventsDetails_cellTittle">OPŁATA OCZEKUJĄCA</p>
                                <p className="eventsDetails_cellContent">
                                    {
                                        props.data.debt.toFixed(2).toString().replace(".",",")}
                                </p>
                            </div>
                            <div className="eventsDetails_cell buttonCage">
                              <CustomButtons clickFunction={openNewWindow} size="small" classButton="outline" >Umowa</CustomButtons>
                            </div>
                        </div>
                    </div>
                ) : (
                    ''
                )}
            </div>
        </>
    );
};

export default EventDetail;
